export default __webpack_public_path__ + "static/media/anoutus (1).679b5817.jpg";